export { DefaultAmplify as Amplify } from './initSingleton.mjs';
